import React, { useEffect } from "react";

const styles = `
.NotFoundWrapper {
  background: #1E1E2E;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-height: 100vh;
}
.NotFoundWrapper .NotFoundText {
  color: #fff;
  font-size: 2rem;
}
.NotFoundGoHome {
  color: #fff;
  font-size: 1rem;
}
`;

function NotFound() {

  useEffect(() => {
    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.innerText = styles;
    document.head.appendChild(styleSheet);

    return () => {
      document.head.removeChild(styleSheet);
    };
  }, [styles]);

  return (
    <div className="NotFoundWrapper">
      <div className="NotFoundText">
        404 - Página Não Encontrada.
      </div>
    </div>
  )
}

export default NotFound;
